import {
  AlertFinancialDocumentEventFragment,
  FinanceValueObjectsFinancialDocumentEventTypeEnum,
  FinancialDocumentEventFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const mapEventTypeIcon = (key: FinanceValueObjectsFinancialDocumentEventTypeEnum) => {
  switch (key) {
    case 'created':
      return 'pencil'
    case 'registered':
      return 'timer'
    case 'tax_document_formatted':
      return 'file-filled'
    case 'tax_document_delivered':
      return 'envelope'
    case 'issued':
      return 'check-circle-line'
    case 'resetted_registered':
      return 'refresh'
    default:
      return key satisfies never
  }
}

export const mapEventText = (key: FinanceValueObjectsFinancialDocumentEventTypeEnum) => {
  switch (key) {
    case 'created':
      return i18n.t('finance.sale_invoices.detail.events_type.created')
    case 'registered':
      return i18n.t('finance.sale_invoices.detail.events_type.registered')
    case 'tax_document_formatted':
      return i18n.t('finance.sale_invoices.detail.events_type.tax_document_formatted')
    case 'tax_document_delivered':
      return i18n.t('finance.sale_invoices.detail.events_type.tax_document_delivered')
    case 'issued':
      return i18n.t('finance.sale_invoices.detail.events_type.issued')
    case 'resetted_registered':
      return i18n.t('finance.sale_invoices.detail.events_type.resetted_registered')
    default:
      return key satisfies never
  }
}

export const getEventErrorMessage = (event: FinancialDocumentEventFragment) => {
  const parts = [i18n.t('finance.sale_invoices.detail.event_status.error')]

  if (event.code) parts.push(event.code)
  if (event.message) parts.push(`- ${event.message}`)

  return parts.join(' ')
}

export const issuedWithErrors = (
  validated?: boolean,
  events?: AlertFinancialDocumentEventFragment[]
) => {
  const errorEvent = events?.find(
    (event) => event.status === 'error' && event.type == 'tax_document_delivered'
  )
  return validated && errorEvent
}

export const draftWithErrorsOnClient = (
  validated?: boolean,
  events?: AlertFinancialDocumentEventFragment[]
) => {
  const lastEvent = events?.at(-1)
  const hasErrorLookingUpCustomer =
    lastEvent &&
    lastEvent.status === 'error' &&
    lastEvent.type == 'resetted_registered' &&
    lastEvent.message?.includes('looking up customer')
  //This check over the message is very fragile:
  //There 2 situations where a 'resetted_registered' event is triggered:
  // 1. When invopop requests fails, error message could be whatever
  // 2. When invopop requests succeeds but client tax id validationstep rejects it
  // The right thing should be checking if a tax bridge data exists for the document.
  // We only have it in the second situation. But we dont have repo for that entity yet

  return !validated && hasErrorLookingUpCustomer
}
